import { auth } from '@/lib/firebase';
import { useCallback } from 'react';
import { toast } from 'sonner';

export const useLoginComfyUIRoute = () => {
  const user = auth.currentUser;

  const getLoggedInComfyUIRoute = useCallback(async (tier: string): Promise<string | void> => {
    try {
      if (!user) return;

      const idToken = await user.getIdToken();

      const response = await fetch('/api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${idToken}`,
        },
        body: JSON.stringify({ action: 'login', tier }),
      });

      if (!response.ok) {
        throw new Error(`Failed to login: ${response.status}`);
      }

      const { data } = await response.json();

      return data?.redirectUrl;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      toast.error(errorMessage);
      return;
    }
  }, []);

  return {
    getLoggedInComfyUIRoute,
  };
};
